import { render, staticRenderFns } from "./examReport.vue?vue&type=template&id=08f648b2&scoped=true&"
import script from "./examReport.vue?vue&type=script&lang=js&"
export * from "./examReport.vue?vue&type=script&lang=js&"
import style0 from "./examReport.vue?vue&type=style&index=0&id=08f648b2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08f648b2",
  null
  
)

export default component.exports